import { ChangeEvent, FC, ReactNode, useEffect, useState } from "react";
import styles from "./SearchBar.module.scss";
import SearchIcon from "./assets/searchIcon.svg";

type SearchBarProps = {
  placeholder?: string;
  searchFunction: (value: string) => void;
  defaultValue?: string;
  doOnChange?: (value: string) => void;
  rightSlot?: ReactNode;
};

export const SearchBar: FC<SearchBarProps> = ({
  placeholder,
  searchFunction,
  defaultValue = "",
  doOnChange,
  rightSlot,
}) => {
  const [value, setValue] = useState<string>(defaultValue);

  const changeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    doOnChange && doOnChange(e.target.value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      searchFunction(value);
      setValue("");
    }
  };
  const handleClick = () => {
    searchFunction(value);
    setValue("");
  };
  // TODO Сделать нормально
  useEffect(() => {
    if (defaultValue !== value) {
      setValue("");
    }
  }, [defaultValue]);
  return (
    <div className={styles.searchBar} data-testid={`test-searchBar`}>
      <input
        type="text"
        placeholder={placeholder}
        onChange={changeHandler}
        value={value}
        onKeyDown={handleKeyDown}
      />
      {rightSlot && <div className={styles.slot}>{rightSlot}</div>}
      <div className={styles.searchIcon}>
        <SearchIcon width={16} height={16} onClick={handleClick} />
      </div>
    </div>
  );
};
